module.exports = ".td-btn{\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./app/sucursal/sucursal.component.css
// module id = 944
// module chunks = 0